import { useEffect } from 'react'
import { Dialog } from '@mui/material'
import { IoClose } from 'react-icons/io5'
import { TbSquareNumber1Filled, TbSquareNumber2Filled, TbSquareNumber3Filled } from 'react-icons/tb'
import { useTranslation } from 'react-i18next'

const YourGuestModal = ({displayModal, setDisplayModal  }) => {
        const { t } = useTranslation('YourGuestModal');
    const handleclose = () => {
        localStorage.setItem("addyourGuestModal", true);
        setDisplayModal(false);

    }
    useEffect(() => {
        const returnmodal = localStorage.getItem("addyourGuestModal");
        setDisplayModal(!returnmodal);
    }, [])
    return (
        <>
          {
             displayModal &&
             (
                <Dialog
                open={true}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "630px",
                    },
                }}
            >
                <div className="bg-white p-5  flex flex-col gap-3 rounded-[20px]">
                    <div className="div">
                        <div className="flex  items-start justify-between w-full ">
                        <span className="text-[18px] font-[600] text-[#131415]">{t('welcome_message')}</span>
                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer'/></span>
                        </div>

                    </div>
                    <div className="bg-[#F6F6F6] p-3 rounded-[9px] grid gap-3 ">
                        <p className='font-[600] text-[#131415] text-[18px] ' >{t('with_your_demo')}</p>
                        <div className='flex gap-2 text-[14px] items-start'>
                            <span><TbSquareNumber1Filled fill='#3686FF' size={25} /></span>
                            <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("title1")}: </span>  {t("description1")} </p>
                        </div>
                        <div className='flex gap-2 text-[14px] items-start'>
                            <span><TbSquareNumber2Filled fill='#3686FF' size={25} /></span>
                            <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("title2")}{t("description2")} </span> </p>
                        </div>
                        <div className='flex gap-2 text-[14px] items-start'>
                            <span><TbSquareNumber3Filled fill='#3686FF' size={25} /></span>
                            <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("title3")}:  </span> {t("description3")}</p>
                        </div>
                        <p className='text-[#535861] text-[14px] pl-1'>{t("explore_platform")}</p>
                        <p className='text-[#535861] text-[14px] pl-1'>{t("contact_info")}</p>
                    </div>
                </div>
            </Dialog >
             )
          }
        </>
    )
}

export default YourGuestModal